import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hotel",
  "use": "icon-hotel-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-hotel\">\n<path d=\"M9.33301 1.33337H1.33301V14.6667H14.6663V7.12462L9.33301 6.0135V1.33337ZM7.99967 5.73573L5.33301 5.18017V13.3334H2.66634V2.66671H7.99967V5.73573ZM6.66634 13.3334V6.81991L13.333 8.2088V13.3334H10.6663V10.6667H9.33301V13.3334H6.66634Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol